module.exports = __webpack_public_path__ + "media/country_flags/mc-8d982da0.png";